declare global {
  interface ClarityFunction {
    (...args: any[]): void;
    q?: IArguments[];
  }

  interface Window {
    clarity?: ClarityFunction;
  }
}

export function initClarity(projectId: string): void {
  if (window.clarity) {
    return;
  }

  window.clarity = (...args: any[]) => {
    (window.clarity!.q = window.clarity!.q || []).push(arguments as unknown as IArguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;

  const firstScript = document.getElementsByTagName('script')[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
}
